export const createDurations = () => {
  const numbersArray = Array.from({ length: 14 }, (_, index) => {
    const datas = {
      value: index + 1,
      label: `${index + 1}`,
    };
    return datas;
  });
  return numbersArray;
};
